<template>
  <div class="page notify__page" :class="{'page__has-bar': !readonly}">
    <div class="page__hd">
      <h1 class="page__title">{{ form.main.no_title }}</h1>
      <p class="page__desc">
        <span v-format="'yyyy-MM-dd'">{{ form.main.no_date }}</span>
        &nbsp;{{ form.main.creatorName }}
      </p>
    </div>
    <html-viewer class="page__bd" v-if="form.main.no_content" :content="form.main.no_content" />
    <file-list v-model="form.main.no_attach" />

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/oa/notify_edit?id='+form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
      >编辑</router-link>
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
      >审核</a>
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
      >删除</a>
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
      >反审</a>
    </div>
  </div>
</template>

<script>
import HtmlViewer from "@/components/HtmlViewer.vue";
import FileList from "@/components/FileList.vue";
import process from "@/mixins/process.js";

export default {
  mixins: [process],
  components: {
    HtmlViewer,
    FileList
  },
  data() {
    return {
      baseUrl: "/api/oa/notify",
      codeField: "no_code",
      statusField: "no_statuscode",
      caller: "Notify",
      xtype: "oa-notify-formpanel",
    };
  }
};
</script>

<style scoped>
.notify__page {
  background: #fff;
}
.notify__page .page__hd {
  padding: 0 20px;
  text-align: center;
}
.notify__page .page__title {
  font-weight: normal;
}
.notify__page .page__desc {
  color: #888;
}
</style>